import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type { RequestOptions } from '../types/common';
import type { RawAgreementResponse } from '../types/agreement';

export function createAgreementApi(http: Http) {
  return {
    /** GET /api/v2/agreements/{agreementType} — 타입별 약관 조회 */
    async byType(agreementType: string, options?: RequestOptions): Promise<RawAgreementResponse> {
      const res = await http.get<RawAgreementResponse>(endpoints.agreement.byType(agreementType), {
        signal: options?.signal,
      });
      return res.data;
    },

    /** GET /api/v2/agreements/terms — 이용약관 */
    async terms(options?: RequestOptions): Promise<RawAgreementResponse> {
      const res = await http.get<RawAgreementResponse>(endpoints.agreement.terms, {
        signal: options?.signal,
      });
      return res.data;
    },

    /** GET /api/v2/agreements/privacy — 개인정보 처리방침 */
    async privacy(options?: RequestOptions): Promise<RawAgreementResponse> {
      const res = await http.get<RawAgreementResponse>(endpoints.agreement.privacy, {
        signal: options?.signal,
      });
      return res.data;
    },

    /** GET /api/v2/agreements/refund — 환불 정책 */
    async refund(options?: RequestOptions): Promise<RawAgreementResponse> {
      const res = await http.get<RawAgreementResponse>(endpoints.agreement.refund, {
        signal: options?.signal,
      });
      return res.data;
    },
  };
}
